import { lazy, Suspense } from 'react';

import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { trpcQueryUtils } from '@web/lib/trpc';

import { AuthContextValue } from '@web/auth';

const TanStackRouterDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null // Render nothing in production
    : lazy(() =>
        // Lazy load in development
        import('@tanstack/router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        })),
      );

type RouterContext = {
  trpcQueryUtils: typeof trpcQueryUtils;
  auth: AuthContextValue;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: function View() {
    return (
      <>
        <Outlet />

        {/* development tools for router and query engines */}
        {/* not rendered on production builds */}
        <Suspense>
          <TanStackRouterDevtools />
        </Suspense>
        <ReactQueryDevtools position="bottom" buttonPosition="bottom-right" />
      </>
    );
  },
});
